import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../../../components/button/button";
import dataVideo from "../../../assets/videos/course_intro.mp4"; // replace with your video

// Accessible accordion component
const Accordion = ({ children }) => (
  <div className="border border-gray-200 divide-y rounded-2xl overflow-hidden shadow-sm">
    {children}
  </div>
);

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="p-4 bg-white hover:bg-gray-50 transition">
      <h3>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex w-full justify-between items-center text-left text-lg font-semibold text-[#0f172a] focus:outline-none transition"
          aria-expanded={isOpen}
        >
          <span>{title}</span>
          <motion.span
            animate={{ rotate: isOpen ? 90 : 0 }}
            transition={{ duration: 0.2 }}
            className="text-gray-600 text-xl"
          >
            ▶
          </motion.span>
        </button>
      </h3>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden mt-3 text-gray-700"
          >
            <ul className="list-disc pl-6 space-y-2">
              {content.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

const CourseDescription = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showDiscountModal, setShowDiscountModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  const accordionData = [
    {
      title: "📊 Introduction to Data Engineering",
      content: [
        "Overview of data engineering and its role in modern organizations",
        "Understanding data architecture, pipelines, and ETL processes",
        "Difference between data engineers, scientists, and analysts",
        "Introduction to cloud computing and big data tools",
      ],
    },
    {
      title: "💻 Python and SQL for Data Engineering",
      content: [
        "Python programming for automation and data manipulation",
        "SQL for querying, cleaning, and transforming datasets",
        "Advanced SQL techniques: joins, window functions, indexing",
        "Hands-on work with relational databases (MySQL, PostgreSQL)",
      ],
    },
    {
      title: "🧱 Data Storage and Management",
      content: [
        "Database design principles and schema optimization",
        "Working with NoSQL databases like MongoDB and Cassandra",
        "Data warehouses and lakes (BigQuery, Redshift, Snowflake)",
        "Data backup, replication, and reliability management",
      ],
    },
    {
      title: "⚙️ ETL and Data Pipeline Development",
      content: [
        "Building scalable ETL pipelines with Airflow and Luigi",
        "Real-time vs batch data processing strategies",
        "Data cleaning, validation, and transformation best practices",
        "Integrating data from multiple sources efficiently",
      ],
    },
    {
      title: "☁️ Big Data & Cloud Platforms",
      content: [
        "Working with Apache Hadoop, Spark, and Kafka",
        "Distributed computing and performance tuning",
        "Cloud-based data engineering with AWS, GCP, and Azure",
        "Serverless data workflows (AWS Lambda, Google Cloud Functions)",
      ],
    },
    {
      title: "🔒 Data Governance, Security & Compliance",
      content: [
        "Implementing data quality checks and validation frameworks",
        "Securing data with encryption and access control",
        "Compliance with GDPR, CCPA, and local regulations",
        "Data lineage and metadata management best practices",
      ],
    },
  ];

  return (
    <div className="w-full bg-gradient-to-b from-white to-[#f9fafb] text-[#1a1a1a] font-inter py-10 px-6 sm:px-10 lg:px-20 relative overflow-hidden">
      {/* HEADER */}
      {/* <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-left mb-10"
      >
        <h1 className="text-4xl font-extrabold tracking-tight text-[#0f172a]">
          Data Engineering Bootcamp
        </h1>
        <p className="text-lg text-gray-600 mt-2 max-w-3xl">
          Master the skills to design, build, and manage large-scale data
          systems that power analytics and AI applications across the world.
        </p>
      </motion.div> */}

      {/* VIDEO */}
      {/* <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="max-w-4xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-xl"
      >
        <video src={dataVideo} controls className="w-full h-[23rem] object-cover" />
      </motion.div> */}

      {/* DESCRIPTION */}
      {/* <section className="max-w-5xl mx-auto mb-12">
        <h2 className="text-2xl font-bold mb-4 text-[#0f172a]">
          What Does a Data Engineer Do?
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          Data engineers are the backbone of modern data-driven organizations.
          They build the infrastructure that collects, stores, and processes
          vast amounts of data. From crafting reliable data pipelines to
          enabling real-time analytics, they ensure that businesses can make
          informed decisions powered by clean, well-structured data.
        </p>
      </section> */}

      {/* WHAT YOU’LL LEARN */}
      {/* <section className="max-w-5xl mx-auto mb-16">
        <h2 className="text-2xl font-bold mb-6 text-[#0f172a]">
          What You’ll Learn
        </h2>
        <Accordion>
          {accordionData.map((item, index) => (
            <AccordionItem key={index} title={item.title} content={item.content} />
          ))}
        </Accordion>
      </section> */}

      {/* COURSE COST */}
      <section className="max-w-6xl mx-auto bg-white rounded-3xl shadow-lg border border-gray-100 p-10 mb-16">
       

        <div className="grid md:grid-cols-2 gap-8">
          {[
            {
              title: "Data Engineering(Weekdays)",
              price: "₦500,000",
              color: "from-sky-500 to-indigo-500",
              modules: [
                "Wednesday 10AM - 3PM",
                "Friday 10AM - 1PM",
                // "Python & SQL for Data Engineering — ₦250,000",
                // "ETL Pipelines & Data Warehousing — ₦150,000",
                // "Big Data & Cloud Technologies — ₦100,000",
                // "Capstone Project & Career Coaching — ",
              ],
            },
            {
              title: "Data Engineering(Weekends)",
              price: "₦750,000",
              color: "from-teal-500 to-green-500",
              modules: [
                "Saturday 10AM - 4PM",
                "Sunday 12PM - 4PM",
                // "Python & SQL for Data Engineering — ₦250,000",
                // "Streaming Data (Kafka, Flink)",
                // "Data Governance & Compliance",
                // "Serverless Data Infrastructure",
                // "Cloud Integration & Cost Optimization",
              ],
            },
          ].map((course, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 p-6"
            >
              <h3
                className={`text-xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r ${course.color}`}
              >
                {course.title}
              </h3>
              <p className="text-2xl font-extrabold text-[#0f172a] mb-6">
                {course.price}
              </p>
              <ul className="space-y-3 text-gray-700 text-sm">
                {course.modules.map((mod, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-100 hover:bg-gray-100 transition"
                  >
                    <span className="text-[#0f172a] font-medium">•</span>
                    <span>{mod}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* AUTO POPUP */}
      {showPopup && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed bottom-8 right-8 bg-[#0f172a] text-white rounded-xl shadow-2xl p-6 w-80 z-50"
        >
          <h3 className="text-lg font-bold mb-2">🎉 Get 20% Off!</h3>
          <p className="text-sm mb-4 text-gray-200">
            Enroll within 24 hours and enjoy 20% off your tuition.
          </p>
          <Button
            btnText="Claim Discount"
            btnClassName="!bg-white !text-[#0f172a] font-semibold w-full py-2 rounded-lg hover:!bg-gray-100 transition"
            onClick={() => setShowDiscountModal(true)}
          />
        </motion.div>
      )}
        {/* FLOATING DISCOUNT BUTTON */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        className="fixed bottom-8 left-8 bg-[#0f172a] text-white font-semibold px-5 py-3 rounded-full shadow-xl hover:bg-[#1e293b] transition z-50"
        onClick={() => setShowDiscountModal(true)}
      >
        💰 Get 20% Discount
      </motion.button>

      {/* DISCOUNT MODAL */}
      <AnimatePresence>
        {showDiscountModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black backdrop-blur-sm z-40"
              onClick={() => setShowDiscountModal(false)}
            />
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="fixed z-50 inset-0 flex items-center justify-center"
            >
              <div className="relative bg-white w-96 rounded-2xl shadow-2xl p-6 text-center">
                {/* Close Button */}
          <button
            onClick={() => setShowDiscountModal(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-semibold transition"
            aria-label="Close discount modal"
          >
            &times;
          </button>

                <h3 className="text-2xl font-bold text-[#0f172a] mb-2">
                  🎁 Claim Your 20% Discount
                </h3>
                <p className="text-gray-600 mb-4 text-sm">
                  Fill in your details below to secure your offer.
                </p>
                <form className="space-y-3">
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  />
                  <select className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Select Course</option>
                    <option value="data_engineering">Data Engineering</option>
                    <option value="data_analysis">Data Analysis </option>
                  </select>
                  <Button
                    btnText="Pay Now & Get 20% Off"
                    btnClassName="!bg-[#0f172a] text-white w-full py-2 rounded-lg hover:!bg-[#1e293b] transition"
                     onClick={() => {
                      window.open("https://paystack.com/buy/data-analysis--data-engineering-ezsole", "_blank");
                    }}
                  />
                </form>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* CTA BUTTON */}
      {/* <div className="text-center mt-16">
        <Link to="/get-started">
          <Button
            btnText="Join the Bootcamp"
            btnClassName="!text-lg !bg-[#0f172a] hover:!bg-[#1e293b] text-white px-10 py-4 rounded-xl shadow-lg hover:shadow-2xl transition duration-300 ease-in-out"
          />
        </Link>
      </div> */}
    </div>
  );
};

export default CourseDescription;
